<template>
    <b-card no-body>
        <!-- <b-card-header>Customisation</b-card-header> -->
        <b-card-body class="p-0 mt-3">
            <b-form>
                <b-row class="mt-2">
                    <b-col cols="4" md="4" lg="4">
                        <h4 class="font-resize">{{ $translate('generic_title') }}</h4>
                    </b-col>
                    <b-col cols="5" sm="6">
                        <h4 class="font-resize">{{ $translate('customised_title') }}</h4>
                    </b-col><b-col cols="3" sm="2">
                        <h4 class="font-resize">{{ $translate('required') }}</h4>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col cols="4">
                        <label id="group-bundled-product" for="input-bundled-product">{{ $translate('bundled_product')
                        }}</label>
                    </b-col>
                    <b-col cols="6"><b-form-input id="input-bundled-product"
                            v-model="settingsData.bundledProduct"></b-form-input> </b-col><b-col cols="2"></b-col>
                </b-row>

                <b-row class="mt-2">
                    <b-col cols="4"><label id="group-secondaryItemsClosingBalances"
                            for="input-secondaryItemsClosingBalances">{{ $translate('secondary_items_balances')
                            }}</label></b-col>
                    <b-col cols="6"><b-form-input id="input-secondaryItemsClosingBalances"
                            v-model="settingsData.secondaryItemsClosingBalances"></b-form-input> </b-col><b-col cols="2">
                        <div class="form-check me-2">
                            <label class="form-check-label">
                                <input type="checkbox" id="checkbox-secondaryItemsClosingBalances" v-model="switches.secondaryItemsClosingBalances
                                    " name="checkbox-secondaryItemsClosingBalances" :value="true"
                                    :unchecked-value="false" />
                                <i class="input-helper"></i>
                            </label>
                        </div>
                    </b-col>
                </b-row>

                <b-row class="mt-2">
                    <b-col cols="4"><label id="group-subProductTotalsBySize" for="input-subProductTotalsBySize">{{
                        $translate('sub_products_totals_by_size') }}</label></b-col>
                    <b-col cols="6"><b-form-input id="input-subProductTotalsBySize"
                            v-model="settingsData.subProductTotalsBySize"></b-form-input> </b-col><b-col cols="2">
                        <div class="form-check me-2">
                            <label class="form-check-label">
                                <input type="checkbox" id="checkbox-subProductTotalsBySize"
                                    v-model="switches.subProductTotalsBySize" name="checkbox-subProductTotalsBySize"
                                    :value="true" :unchecked-value="false" />
                                <i class="input-helper"></i>
                            </label>
                        </div>
                    </b-col>
                </b-row>

                <b-row class="mt-2" v-for="(heading, idx) in headings" :key="idx + 'heading'">
                    <b-col cols="4"><label id="fieldset-horizontal" :for="`input-${idx}`">{{ heading }}</label></b-col>
                    <b-col cols="6"><b-form-input :id="`input-${idx}`" v-model="settingsData[heading]"></b-form-input>
                    </b-col><b-col cols="2">
                        <div class="form-check me-2">
                            <label class="form-check-label">
                                <input type="checkbox" :id="`checkbox-${heading}`" v-model="switches[heading]"
                                    :name="`checkbox-${heading}`" :value="true" :unchecked-value="false" />
                                <i class="input-helper"></i>
                            </label>
                        </div>
                        <!-- <b-form-checkbox></b-form-checkbox> -->
                    </b-col>
                </b-row>

                <b-row class="mt-2"><b-col cols="4">
                        <label>{{ $translate('bundled_display_type') }}</label>
                    </b-col>
                    <b-col class="d-flex">
                        <div class="form-check me-2" v-for="(item, idx) in bundledDisplayOptions"
                            :key="'settingsData' + idx">
                            <label class="form-check-label">
                                <input type="radio" class="form-check-input" name="radio-inline"
                                    v-model="settingsData.bundledProductType" :value="item.value" />
                                {{ item.text }}
                                <i class="input-helper"></i>
                            </label>
                        </div>
                    </b-col>
                </b-row>

                <b-row class="mt-4"><b-col cols="12" class="text-center">
                        <b-button variant="blue-button" @click="updateConfiguration">
                            <span>{{ $updateLabel() }}</span>
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-card-body>
    </b-card>
</template>

<script>
import { capitalCase } from 'change-case'
import settingsMixins from '@/mixins/settingsMixins'
import popupMixins from '@/mixins/popupMixins'
const settingsKeyName = 'inventoryUsageKey'
export default {
    name: 'DailyUsageSettings',
    mixins: [popupMixins, settingsMixins],
    data() {
        return {
           
            settingsKeyName,
            settingsData: {},
            switches: {},
            loading: false,
        }
    },
    filters: {
        formatTitle(val) {
            return capitalCase(val)
        },
    },

    props: {
        headings: {
            type: Array,
            require: true,
        },
        formData: { type: Object, default: () => ({}) },
        bundledList: { type: Array, default: () => [] },
        minorList: { type: Array, default: () => [] },
        saveSettingsCounter: { type: Number },
    },
    computed: {
        bundledDisplayOptions() {
            return [
                { text: this.$translate('primary_products'), value: 'primary' },
                { text: this.$translate('both_products'), value: 'both' },
            ]
        },
    },

    watch: {
        saveSettingsCounter: function () {
            this.updateConfiguration()
        },
        configurationSettings: {
            handler: function (val) {
                this.setSettingsData(val)
            },
            deep: true,
        },
        loading: function (val) {
            this.$emit('set-loading-state', val)
        },
    },

    mounted() {
        const { configurationSettings: settings } = this
        this.setSettingsData(settings)
    },

    methods: {
        setSettingsData(settings) {
            const otherHeadings = [
                'bundledProductType',
                'bundledProduct',
                'subProductTotalsBySize',
                'secondaryItemsClosingBalances',
            ]
            settings = settings || {}

            for (const key of [...this.headings, ...otherHeadings]) {
                const { title, required } = settings[key] || {}
                this.$set(this.settingsData, key, title)
                this.$set(this.switches, key, !!required)
            }

            this.$emit('updating-settings', settings)
        },

        async updateConfiguration() {
            try {
                this.loading = true
                const { settingsData: headings, switches } = this
                const settings = {}

                for (const key in headings) {
                    const title = headings[key]
                    const required = !!switches[key]
                    this.$set(settings, key, { title, required })
                }

                this.$set(settings, 'bundledList', this.bundledList)
                this.$set(settings, 'minorList', this.minorList)
                this.$set(settings, 'formData', this.formData)

                const text_value = JSON.stringify(settings)
                const bool_value = false
                const key = this.settingsKey
                // const { settingsKeyName, settingsKey } = this
                await this.$store.dispatch('company/updateConfiguration', {
                    key,
                    text_value,
                    bool_value,
                })

                this.doToast(
                    this.$translate('success'),
                    `${this.$translate('settings')} ${this.$translate('update_alert')}`,
                    'success'
                )
            } catch (err) {
                console.error(err.message)
                this.doToast(
                    this.$translate('error'),
                    `${err.message}`,
                    'danger'
                )
            } finally {
                this.loading = false
            }
        },
    },
}
</script>

<style></style>
